// Saída do escritório: quando a sessão fecha, o personagem anda até o elevador do andar (o móvel
// 'elevador' na parede do terraço) e some lá. Se o andar não tem elevador, some na porta da sala.
//
// Puro, exceto avisaElevador: dispara o evento window 'agzos:elevador' para o módulo de som
// (o 'ding'), sem tocar som aqui.

import { FURNITURE_BY_ID } from '../art/furniture/index.js';
import { roomData } from '../engine/room-data.js';
import type { CampusFloor } from './layout.js';

/** Quanto tempo o personagem leva para sumir depois de chegar ao elevador (ou à porta), em ms. */
export const SAIDA_FADE_MS = 600;
/** Nome do evento que o elevador dispara quando alguém sai por ele. */
export const EVENTO_ELEVADOR = 'agzos:elevador';

export interface AlvoDaSaida {
  /** Tile caminhável em frente ao elevador. */
  x: number;
  y: number;
}

/**
 * Tile de parada para sair pelo elevador: o caminhável logo abaixo do móvel, na primeira sala do
 * andar que tem um. null quando o andar não tem elevador (aí a saída é pela porta da sala).
 */
export function alvoDaSaida(floor: CampusFloor): AlvoDaSaida | null {
  const largura = FURNITURE_BY_ID.get('elevador')?.footprint.w ?? 1;
  for (const placed of floor.rooms) {
    const item = placed.map.items.find((p) => p.item === 'elevador');
    if (!item) continue;
    const frente = roomData(placed.map).walkable[item.y + 1] ?? [];
    // para em frente ao primeiro tile do móvel que dá para pisar
    for (let dx = 0; dx < largura; dx++) {
      if (frente[item.x + dx]) return { x: placed.x + item.x + dx, y: placed.y + item.y + 1 };
    }
  }
  return null;
}

/** Avisa que alguém saiu pelo elevador (o módulo de som escuta 'agzos:elevador'). */
export function avisaElevador(agente: string): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(EVENTO_ELEVADOR, { detail: { acao: 'saida', agente } }));
}
